import '../styles/main.css'
import { initPieces } from '../pieces/registry.js'

initPieces()

// Theme editor and AJAX section re-renders
document.addEventListener('shopify:section:load', (event) => {
  initPieces(event.target)
})

document.addEventListener('shopify:section:unload', (event) => {
  initPieces(event.target)
})
